import { useRef } from "react";

import { areArraysEqual } from "../utils/arrays";

export function useMemoizedArray<V>(array: V[]) {
  const ref = useRef(array);

  if (!areArraysEqual(ref.current, array)) {
    ref.current = array;
  }

  return ref.current;
}
